import React, {useEffect, useLayoutEffect, useMemo, useState} from 'react';
import {connect} from 'react-redux';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';
import EpiContext from '@episerver/spa-core/Spa';
import Config from 'app/Config';
import {buildUrlAndOpenWindow} from '../../../utilities/StringHelpers/StringHelpers';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import {goToPage, initPage, setSelectedSubscriber, resetPage} from './SelfCareSlice';
import {getSelfCareData, getTrackerItems} from './SelfCareAsyncThunk';
import SubscriberSwiper from './partials/SubscriberSwiper/SubscriberSwiper';
import {worldEnum, internalPage, TAB_ENUM} from './Constant';
import {checkLoginData} from './Utilities';
import ServiceDetailsPage from './pages/ServiceDetailsPage/ServiceDetailsPage';
import {setRedirectUrl} from '../../../utilities/authentication/authenticationSlice';
import FullFinancedErrorPage from './partials/ErrorPages/FullFinancedErrorPage';

const SelfCare = React.memo(
  (props) => {
    console.log(props);
    const isEcellcomFlagOn = props?.startPage?.isShowEcellcom?.value ?? false; // to take from episerver
    const isUserConnected = checkLoginData(props.authentication.loginData);
    const isUserFullFinanced = props.authentication.loginData?.userDetails?.IsFullFinance;
    const worldType = worldEnum[props.iContent.worldType.value];
    const [hasProductsInWorld, setHasProductsInWorld] = useState(false);
    const [isEcellcomFlagOnAndUserDoesNotHaveCell, setIsEcellcomFlagOnAndUserDoesNotHaveCell] = useState(false);

    //--------------- useEffect ---------------

    useLayoutEffect(() => {
      if (!isUserConnected) {
        props.resetPage();
        props.setRedirectUrl(window.location.pathname);
        const loginPath = `${Config.staticWebSiteUrl}${Config.newLoginUrl}?returnUrl=${window.location.pathname}`;
        window.location.replace(loginPath);
      }
      if (isUserFullFinanced) {
        props.goToPage(internalPage.FullFinancedErrorPage);
      }
    }, [isUserConnected, isUserFullFinanced]);

    useExtendedEffect(
      (runSideEffects) => {
        if (!props.isFetchData && isUserConnected) {
          props.getSelfCareData();
        }
        if (runSideEffects()) {
        }
      },
      [props.isFetchData],
    );

    useEffect(() => {
      if (worldType === TAB_ENUM.Main && isUserConnected) {
        props.getTrackerItems();
      }
    }, [props.iContent.worldType.value]);

    useExtendedEffect(
      (runSideEffects) => {
        props.initPage(props.iContent);
      },
      [props.iContent],
    );

    useEffect(() => {
      if (worldType === TAB_ENUM.Main || !props.isFetchData) {
        setHasProductsInWorld(true);
      } else if (props.subscribersByProduct?.[worldType]) {
        setHasProductsInWorld(true);
      } else {
        setHasProductsInWorld(false);
      }
    }, [props.iContent.worldType.value, props.isFetchData]);

    useEffect(() => {
      if (props.subscribersByProduct?.[worldType]) {
        if (!props.retainSubscriberOnLoad) {
          if (props.selectedSubscriber?.productType == worldType && props.isFetchData) {
            var fullSubscriberData = props.subscribersByProduct[worldType].find(
              (sub) => sub.productSubscriberNo === props.selectedSubscriber.productSubscriberNo,
            );
            props.setSelectedSubscriber(fullSubscriberData);
          } else {
            props.setSelectedSubscriber(props.subscribersByProduct[worldType][0]);
          }
        }
        if (isEcellcomFlagOn) {
          const keys = Object.keys(props.subscribersByProduct);
          if (!keys.includes(TAB_ENUM.Cellular)) {
            setIsEcellcomFlagOnAndUserDoesNotHaveCell(true);
          } else {
            setIsEcellcomFlagOnAndUserDoesNotHaveCell(false);
          }
        }
      }
    }, [props.iContent.worldType.value, props.isFetchLoginData, props.isFetchData]);

    const getInternalPage = useMemo(() => {
      switch (props.page) {
        case internalPage.ServiceDetailsPage:
          return <ServiceDetailsPage />;
        case internalPage.FullFinancedErrorPage:
          return <FullFinancedErrorPage Config={Config} EpiContext={EpiContext} />;
        default:
          return null;
      }
    }, [props.page]);
    const filteredContent = props.iContent.mainContentAreaWithoutProducts.expandedValue
      ? props.iContent.mainContentAreaWithoutProducts.expandedValue.filter((obj) => obj?.isEcellcom?.value !== true)
      : null;
    return (
      <>
        {isUserConnected ? (
          <div className='selfcare-page-content'>
            {props.page !== internalPage.Main ? (
              <div className='selfcare_internal_page'>{getInternalPage}</div>
            ) : (
              <>
                {hasProductsInWorld ? (
                  <>
                    {props.worldType !== worldEnum.Main && <SubscriberSwiper />}
                    <ContentArea
                      noWrap
                      key='MainContentArea'
                      context={props.context}
                      data={props.iContent.mainContentArea}
                      propertyName='MainContentArea'
                    />
                  </>
                ) : (
                  <ContentArea
                    noWrap
                    key='MainContentAreaWithoutProducts'
                    context={props.context}
                    data={
                      isEcellcomFlagOnAndUserDoesNotHaveCell && props.worldType === worldEnum.Abroad
                        ? filteredContent
                        : props.iContent.mainContentAreaWithoutProducts
                    }
                    propertyName='MainContentAreaWithoutProducts'
                  />
                )}
              </>
            )}
          </div>
        ) : (
          <div style={{height: '100vh'}}></div>
        )}
      </>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.worldType === nextProps.worldType && prevProps.isFetchData === nextProps.isFetchData && prevProps.page === nextProps.page
    );
  },
);

const mapStateToProps = (state) => {
  return {
    page: state.selfcarePage?.page,
    isFetchData: state.selfcarePage?.isFetchData,
    authentication: state.authentication,
    worldType: state.selfcarePage?.epiData?.worldType,
    subscribersByProduct: state.selfcarePage?.subscribersByProduct,
    selectedSubscriber: state.selfcarePage?.selectedSubscriber,
    retainSubscriberOnLoad: state.selfcarePage?.retainSubscriberOnLoad,
    showExtendedPopup: state.selfcarePage?.showExtendedPopup,
  };
};
const mapDispatchToProps = {initPage, getSelfCareData, getTrackerItems, setSelectedSubscriber, goToPage, resetPage, setRedirectUrl};
export default connect(mapStateToProps, mapDispatchToProps)(SelfCare);
